import { GroupForLmsQuery, GroupLessonType } from 'core/graphql';
import { isBeforeNow } from 'services/DateService';
import { GroupTypes, LessonType } from 'components/types';
import { ICourseInfo } from 'molecules/CourseProgram/CourseInfo';
import { LessonSkill, ProgramLessonType } from 'components/types/lesson';

export const transformCourse = (data: GroupForLmsQuery | undefined): ICourseInfo => {
  if (data?.groupForLms?.__typename) {
    const groupType: GroupTypes = data.groupForLms.__typename as GroupTypes;

    // ТЗ 0040 доводка: навыки, которые даёт занятие. Раскладываем ПО ID —
    // номер занятия в системе считается тремя разными способами, и два из
    // них идут по дате.
    const planByLesson = new Map<string, { skills: LessonSkill[]; isOver: boolean }>();
    // @ts-ignore — поле есть только у студенческого типа группы
    (data.groupForLms.skillPlan ?? []).forEach((row: any) => {
      if (row?.lessonId) {
        planByLesson.set(String(row.lessonId), {
          skills: row.skills ?? [],
          isOver: Boolean(row.isOver),
        });
      }
    });

    const result: ProgramLessonType[] =
      // @ts-ignore
      data.groupForLms.lessons?.reduce(
        (lessons: LessonType[], lessonData: GroupLessonType, index: number) => {
          const isEnded = isBeforeNow(lessonData.date);

          const accumulator: ProgramLessonType = {
            id: lessonData.id,
            name: lessonData.name,
            index: lessonData.index || index,
            isEnded,
            isActive: !isEnded,
            needToFinish: groupType === GroupTypes.GroupType ? lessonData.needToFinish : null,
            skills: planByLesson.get(String(lessonData.id))?.skills ?? [],
            skillsGranted: planByLesson.get(String(lessonData.id))?.isOver ?? false,
          };

          return [...lessons, accumulator];
        },
        [],
      ) || [];

    return {
      courseImageURL: data.groupForLms.course.courseIcon || '',
      courseName: data.groupForLms.course.name || '',
      groupName: data.groupForLms.name || '',
      studentsCount: data.groupForLms.studentsCount || 0,
      passedLessonsCount: data.groupForLms.passedLessonsCount || 0,
      lessons: result,
      lessonsCount: data.groupForLms.lessonsCount || 0,
      isFinished: data.groupForLms.statusFinished,
      isFree: data.groupForLms.isFree || false,
    };
  }

  return {
    courseImageURL: '',
    courseName: '',
    groupName: '',
    studentsCount: 0,
    passedLessonsCount: 0,
    lessons: [],
    lessonsCount: 0,
  };
};
